import { render, staticRenderFns } from "./vehicleLicenseList.vue?vue&type=template&id=44a60698&scoped=true"
import script from "./vehicleLicenseList.vue?vue&type=script&lang=js"
export * from "./vehicleLicenseList.vue?vue&type=script&lang=js"
import style0 from "./vehicleLicenseList.vue?vue&type=style&index=0&id=44a60698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a60698",
  null
  
)

export default component.exports